import React from 'react'
import Columns from '../generic/Columns'
import Column from '../generic/Column'

const CardHeaderTemplate = (props) => {
  if (!props.text) {
    return null
  }
  return (
    <header className='header-title'>
      <p className='card-header-title'>
        {props.text}
      </p>
    </header>
  )
}

const CardContentTemplate = (props) => {
  return (
    <div className='card-content has-text-centered'>
      <div className='content'>
        {props.children}
      </div>
    </div>
  )
}

const CardFooterTemplate = (props) => {
  if (!props.items) {
    return null
  }
  return (
    <div className='card-footer'>
      {props.items.map(data => data)}
    </div>
  )
}

const Cards = (props) => {
  const cardsData = props.cardsData.map((data, i) => {
    return {...data, key: i}
  })
  return (
    <Columns isMultiline>
      {cardsData.map(data => {
        return (
          <Column className='is-4' key={data.key}>
            <div className='card app-card'>
              <CardHeaderTemplate text={data.header} />
              <CardContentTemplate>
                {data.content}
              </CardContentTemplate>
              <CardFooterTemplate items={data.items} />
            </div>
          </Column>
        )
      })}
    </Columns>
  )
}

export default Cards



// WEBPACK FOOTER //
// ./src/components/generic/Cards.js